<template>
  <div>
    <TopoComponent></TopoComponent>
    <div class="container vertical-align login escolha mt-4">
      <div class="row">
        <div class="col-md-5">
          <div v-if="titular">
            <h2>Crie a senha da sua conta</h2>
            <p class="font-weight-normal h6">
              Crie uma senha segura para proteger sua conta.
            </p>
          </div>
          <div v-else>
            <h2>Crie uma senha para {{ dependente.nome.split(" ")[0] }}</h2>
            
            <p class="font-weight-normal h6">Crie uma senha segura para proteger a conta deste dependente</p>
          </div>
          <form class="form-signin">
            <div class="relative mt-4">
              <input
                type="password"
                id="inputSenha"
                class="form-control"
                placeholder="Senha"
                required="true"
                v-model="senha"
              />
              <svg
                id="niver"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g fill="none" fill-rule="evenodd">
                  <path d="M0 0h24v24H0z" />
                  <path
                    :stroke="layout === 'docpass' ? '#6f999c' : '#3CB4E7'"
                    stroke-width="2"
                    d="M12.64 4.383a5.997 5.997 0 0 1 1.58 5.693l6.765 6.765-1.21 2.39-3.295.187a1 1 0 0 1-1.01-1.303l.092-.288a.711.711 0 0 0-.968-.865.61.61 0 0 1-.807-.803l.02-.044a.523.523 0 0 0-.731-.67l-.7.383a1 1 0 0 1-1.188-.17L9.95 14.423a6 6 0 1 1 2.69-10.04zM9.105 6.504a2 2 0 1 0-2.829 2.829 2 2 0 0 0 2.829-2.829z"
                  />
                </g>
              </svg>
            </div>
            <div class="relative mt-4">
              <input
                type="password"
                id="inputConfirmacaoSenha"
                class="form-control"
                placeholder="Confirmação de Senha"
                required="true"
                v-model="confirmacaoSenha"
              />
              <svg
                id="niver"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g fill="none" fill-rule="evenodd">
                  <path d="M0 0h24v24H0z" />
                  <path
                    :stroke="layout === 'docpass' ? '#6f999c' : '#3CB4E7'"
                    stroke-width="2"
                    d="M12.64 4.383a5.997 5.997 0 0 1 1.58 5.693l6.765 6.765-1.21 2.39-3.295.187a1 1 0 0 1-1.01-1.303l.092-.288a.711.711 0 0 0-.968-.865.61.61 0 0 1-.807-.803l.02-.044a.523.523 0 0 0-.731-.67l-.7.383a1 1 0 0 1-1.188-.17L9.95 14.423a6 6 0 1 1 2.69-10.04zM9.105 6.504a2 2 0 1 0-2.829 2.829 2 2 0 0 0 2.829-2.829z"
                  />
                </g>
              </svg>
            </div>
            <g-recaptcha
              data-sitekey="6LcQB_EUAAAAAPGeh3IGuaY5gWca1ig2BzQOsODm"
              :data-validate="validate"
              :data-callback="cadastrarNovaSenha"
              :disabled="processingRequest"
              data-btn-class="btn btn-lg btn-primary btn-block button success mt-4"
            >
              {{ labelBotao }}
            </g-recaptcha>
          </form>
        </div>
        <div class="col-md-7">
          <img
            :src="image('medico.svg')"
            alt=""
            class="img-fluid float-right medico no-top"
          />
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopoComponent from "@/components/TopoComponent";
import { getImage } from "@/components/utils/fnUtils";
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";
import axios from "axios";

export default {
  components: { TopoComponent, gRecaptcha },
  name: "cadastrarSenha",
  props: ["tipoDeUsuario", "indiceDependente"],
  data() {
    return {
      userToken: sessionStorage.getItem("token"),
      idClinica: sessionStorage.getItem("idclinica"),
      layout: sessionStorage.getItem("layout"),
      senha: null,
      confirmacaoSenha: null,
      dependentes: null,
      processingRequest: false,
      cadastroOK: false,
      labelBotao: "Continuar",
      linkTerms: sessionStorage.getItem("urlTermo"),
      resCadastro: {},
    };
  },
  computed: {
    titular() {
      return this.tipoDeUsuario === "titular";
    },
    idDependente() {
      return this.dependente.idDependente;
    },
    dependente() {
      if (this.indiceDependente === undefined) return null;
      const dependentes = JSON.parse(sessionStorage.getItem("dependentes"));
      const dependente = dependentes[parseInt(this.indiceDependente)];
      return dependente;
    },
    token() {
      if (this.titular) return this.userToken;
      const dependentes = JSON.parse(sessionStorage.getItem("dependentes"));
      const dependente = dependentes[this.indiceDependente];
      return dependente.token;
    },
  },
  mounted: function() {
    if (this.titular) {
      this.userToken = sessionStorage.getItem("token");
    }
  },
  methods: {
    validate() {
      return true;
    },
    image(name) {
      return getImage(name);
    },
    salvarDependenteParaAtivar(dependente) {
      const dependentesParaAtivar = JSON.parse(sessionStorage.getItem("dependentesParaAtivar")) || [];
      if (dependentesParaAtivar.find(item => item.id === dependente.id)) {
        return
      }
      dependentesParaAtivar.push(dependente)
      sessionStorage.setItem("dependentesParaAtivar", JSON.stringify(dependentesParaAtivar));
    },
    cadastrarNovaSenha(token) {
      if (this.senha == null) {
        this.$notify({
          group: "mensagens",
          type: "error",
          text: "Senha não informada.",
        });
        return false;
      }
      if (this.confirmacaoSenha == null) {
        this.$notify({
          group: "mensagens",
          type: "error",
          text: "Confirmação de senha não informada.",
        });
        return false;
      }
      this.processingRequest = true;
      this.labelBotao = "Processando...";
      axios
        .post(
          process.env.VUE_APP_ROOT_API +
            "/integration/ativacao/paciente/" +
            this.token +
            "/cadastrar-senha",
          {
            senha: this.senha,
            confirmacaoSenha: this.confirmacaoSenha,
          },
          { headers: { captcha: token } }
        )
        .then((res) => {
          if (this.titular) {
            const dependentes = res.data.object.dependentes;
            sessionStorage.setItem("totaldependentes", dependentes.length);
            sessionStorage.setItem("dependentes", JSON.stringify(dependentes));
            if (dependentes.length > 0) {
              this.$router.push("/selecionar-dependente");
            } else {
              this.$router.push("/termos-e-condicoes");
            }
          } else {
            let dependentes = JSON.parse(sessionStorage.getItem("dependentes"));
            dependentes = dependentes.filter((dependente) => {
              return parseInt(dependente.idDependente) !== parseInt(this.dependente.idDependente);
            });
            this.salvarDependenteParaAtivar(this.dependente)
            this.$notify({
              duration: 4000,
              group: "mensagens",
              type: "success",
              title: "Mensagem",
              text: "Dependente ativado com sucesso!",
            });
            sessionStorage.setItem("dependentes", JSON.stringify(dependentes));
            sessionStorage.setItem("totaldependentes", dependentes.length);
            if (dependentes.length == 0) {
              this.$router.push("/termos-e-condicoes");
            } else {
              this.$router.push("/selecionar-dependente");
            }
          }
        })
        .catch((error) => {
          this.$notify({
            duration: 4000,
            group: "mensagens",
            type: "error",
            title: "Atenção",
            text: error.response.data.msg,
          });
        })
        .finally(() => {
          NProgress.done();
          if (!this.cadastroOK) {
            this.processingRequest = false;
          }
          this.labelBotao = "Salvar";
        });
    },
  },
};
</script>

<style scoped>
.st0 {
  fill: #6fb0e3;
}
.form-signin {
  padding: unset !important;
  margin: 0 0 0 23px;
}
.termos-body {
  padding: 23px;
  color: black;
}
.termos-footer {
  width: 100%;
  margin: 0 0 20px 0;
  padding-right: 36px !important;
  display: flex;
  justify-content: flex-end;
  max-width: unset;
}
</style>
